import { FC, useCallback } from "react";
import { AnyTask, Market } from "tm-shared/types";

import { ItemListView } from "@/components/ItemListView";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { AssignmentWithContext } from "@/pages/Assignments/AssignmentsPage/AssignmentPage.types";
import { setAssignmentActiveCollapseId } from "@/store/slices/ui";

import { AssignmentBody } from "../AssignmentBody";
import { AssignmentHeader } from "../AssignmentHeader";

interface AssignmentMarketListProps {
    assignmentsWithContext: AssignmentWithContext[];
    onOpenTasksInfoModal: (params: { task: AnyTask; market: Market }) => void;
}

export const AssignmentMarketList: FC<AssignmentMarketListProps> = ({
    assignmentsWithContext,
    onOpenTasksInfoModal,
}) => {
    const dispatch = useAppDispatch();

    const { activeCollapseId } = useAppSelector((s) => s.ui.assignments.page);

    const onChangeCollapse = useCallback(
        (id?: string) => {
            dispatch(setAssignmentActiveCollapseId(id));
        },
        [dispatch],
    );

    return (
        <ItemListView
            items={assignmentsWithContext}
            onChangeCollapse={onChangeCollapse}
            HeaderComponent={AssignmentHeader}
            BodyComponent={AssignmentBody}
            activeCollapse={activeCollapseId}
            bodyProps={{ onOpenTasksInfoModal }}
        />
    );
};
